 export default {
 "help_title": "Help & Support",
  "help_subtitle": "Manage your business smoothly with guided help and documentation.",

  "help_profile_title": "Complete Profile",
  "help_profile_desc": "Complete your business and store profile to unlock all features.",
  "help_profile_btn": "Go to Profile",

  "help_dashboard_title": "Guided Dashboard Tour",
  "help_dashboard_desc": "Step-by-step walkthrough to understand orders, invoices and tools.",
  "help_dashboard_btn": "Start Tour",

  "help_tools_title": "Tools & Features",
  "help_tools_desc": "Learn how to use inventory, offers, invoices and reports efficiently.",
  "help_tools_btn": "Explore Tools",

  "help_docs_title": "Documentation",
  "help_docs_desc": "Access detailed documentation with examples and best practices.",
  "help_docs_btn": "View Docs",

  "help_support_title": "Still Need Help?",
  "help_support_desc": "Reach out to our support team for quick assistance.",
  "help_support_btn": "Contact Support",
 }